export enum ErrorCode {
    NoError = 0,
    DuplicatePayment = 990,
    GeneralError = 1000,
    PaymentFailed = 1001,
    Shift4PaymentError = 1002,
    CheckAlreadyPaid = 1003,
    PaymentAmountExceedsAmountDue = 1004,
    ClaimAmountsChanged = 1005,
    SystemOffline = 1006,
    GuestNotFound = 1007,
    GuestCannotCharge = 1008,
    ParPaymentCompleteNoUpdatedOrder = 1009,
    PaymentFailedDeclined = 1010,
    PaymentFailedInsufficientFunds = 1011,
    PaymentFailedExpiredCards = 1012,
}